// extracted by mini-css-extract-plugin
export default {"messageListing":"styles_messageListing__HA9wp","itemHeader":"styles_itemHeader__Xz3PC"};